module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/198-argentina-c63ec26cbdc1d37671a10456f2641a2a.svg";